
import { Button } from '@/components/ui/button';
import { RefreshCw, MessageSquare, Globe, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FeedbackButton } from '@/components/feedback/FeedbackButton';
import { useAnalytics } from '@/hooks/use-analytics';
import { useState } from 'react';
import { CreateGroupDialog } from './groups/CreateGroupDialog';
import { toast } from '@/hooks/use-toast';

interface CommunityHeaderProps {
  isRefreshing: boolean;
  onRefresh: () => void;
}

const CommunityHeader = ({ isRefreshing, onRefresh }: CommunityHeaderProps) => {
  const { t } = useTranslation('community');
  const { trackFeatureUse } = useAnalytics();
  const [isCreateGroupOpen, setIsCreateGroupOpen] = useState(false);

  const trackNavigation = (destination: string) => {
    trackFeatureUse('navigation', {
      from: 'community',
      to: destination
    });
  };

  const handleCreateGroup = () => {
    trackFeatureUse('create_group', { action: 'open_dialog' });
    setIsCreateGroupOpen(true);
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
      <div>
        <h1 className="text-3xl font-bold text-unimog-800 dark:text-unimog-200 mb-2">
          {t('page_title')}
        </h1>
        <p className="text-muted-foreground max-w-2xl">
          {t('page_subtitle')}
        </p>
      </div>
      <div className="flex gap-2 flex-wrap">
        <FeedbackButton />
        <Button
          variant="outline"
          onClick={onRefresh}
          disabled={isRefreshing}
          className="flex items-center gap-2"
        >
          <RefreshCw size={16} className={isRefreshing ? "animate-spin" : ""} />
          <span>{t('header.refresh')}</span>
        </Button>
        <Button
          variant="outline"
          onClick={handleCreateGroup}
          className="flex items-center gap-2"
        >
          <Users size={16} />
          <span>{t('header.create_group')}</span>
        </Button>
        <Button
          asChild
          variant="outline"
          className="flex items-center gap-2"
          onClick={() => trackNavigation('messages')}
        >
          <Link to="/messages">
            <MessageSquare size={16} />
            <span>{t('header.messages')}</span>
          </Link>
        </Button>
        <Button
          asChild
          className="bg-primary flex items-center gap-2"
          onClick={() => trackNavigation('vehicle_showcase')}
        >
          <Link to="/community/members">
            <Globe size={16} />
            <span>{t('header.vehicle_showcase')}</span>
          </Link>
        </Button>
      </div>
      
      <CreateGroupDialog 
        open={isCreateGroupOpen} 
        onOpenChange={setIsCreateGroupOpen}
      />
    </div>
  );
};

export default CommunityHeader;
